import apisauce from 'apisauce'

import Config from '@/config'
import { TokenSession } from '@/services/session'
import Mocks from './mock'
import Middleware from './middleware'
import Endpoints from './endpoints'
import { notifyActionFactory } from './utils/promiseHandling'
import { restoreProblemClassification } from './utils'

export * from './utils/promiseHandling'

let api = null
let apiWithEndPoints = null
let actions = null

/**
 * Actions params
 * They are an methods to manage error/response in middleware Api.
 * If exist onSignout in actions, it is executed on received 401 HTTP Error.
 * @param {Object} actions
 */
export const create = (config) => {
    actions = (config || {}).actions || {}
    api = apisauce.create(Config.api)
    restoreProblemClassification(api)
    // Manage token
    const token = TokenSession.get()
    if (token) setAuthorizationHeader(token)
    // Create API
    apiWithEndPoints = Endpoints.create(api)
    // Middleware
    api.axiosInstance.interceptors.response.use(
        response => Middleware.responseHandler({ response, ...config }),
        error => Middleware.errorHandler({ error, setAuthorization, ...config }),
    )
    // Manage mocks
    if (Config.isTest || Config.useMock) Mocks(api.axiosInstance)

    return apiWithEndPoints
}

/**
 * Set Auth session
 * @param {Object} token - Token
 * @param {string} token.type - Token type `Bearer`
 * @param {string} token.token - Token value
 */
export const setAuthorization = (token) => {
    TokenSession.set(token)
    setAuthorizationHeader(token)
}

/**
 * Set Auth Headers
 * @param {Object} token
 * @param {string} token.type - Token type `Bearer`
 * @param {string} token.token - Token value
 */
const setAuthorizationHeader = ({ type = null, token = null }) => {
    if (api && token && type) api.setHeaders({ Authorization: `${type} ${token}` })
}

/**
 * Remove Auth Headers
 */
export const removeAuthorization = async () => {
    TokenSession.unset()
    if (api) api.deleteHeader('Authorization')
}

/**
 * Notify Actions
 */
export const notifySuccess = notif => notifyActionFactory({ type: 'success', send: actions.sendNotification })(notif)
export const notifyError = notif => notifyActionFactory({ type: 'error', send: actions.sendNotification })(notif)
export const notifyInfo = notif => notifyActionFactory({ type: 'info', send: actions.sendNotification })(notif)
export const notifyHttpError = notif => notifyActionFactory({ error: actions.sendError })(notif)

/**
 * Instance
 */
export const getApiInstance = () => api

/**
 * Endpoints
 */
export const Api = () => apiWithEndPoints

export default {
    create,
    Api,
    getApiInstance,
    setAuthorization,
    removeAuthorization,
}
